import { Currency } from 'src/api/currency'
import * as R from 'ramda'

export function sumAmounts(amounts: { amount: number; currency: Currency }[]): { amount: number; currency: Currency }[] {
  const byCurrency = R.groupBy(({ currency }: { amount: number; currency: Currency }) => currency)
  const groupedByCurrency = byCurrency(amounts)
  const result: { amount: number; currency: Currency }[] = []
  for (const key in groupedByCurrency) {
    const currency = key as Currency
    const sum = R.sum(groupedByCurrency[currency].map((c) => c.amount))
    result.push({ amount: sum, currency })
  }
  return result
}
